import { ClientPortalAvailableDefaultLanguageEnum } from '../../../shared/models';

export const isClientPortalAvailableDefaultLanguage = (
  language: string,
): language is ClientPortalAvailableDefaultLanguageEnum => {
  return (
    Object.values(ClientPortalAvailableDefaultLanguageEnum) as string[]
  ).includes(language);
};
